import { render, staticRenderFns } from "./Sys_userpriv.vue?vue&type=template&id=1beb9378&scoped=true&"
import script from "./Sys_userpriv.vue?vue&type=script&lang=js&"
export * from "./Sys_userpriv.vue?vue&type=script&lang=js&"
import style0 from "./Sys_userpriv.vue?vue&type=style&index=0&id=1beb9378&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb9378",
  null
  
)

export default component.exports